import {atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'

export const ptaButtonProps = {
  design: atomButtonDesigns.SOLID,
  fullWidth: true,
  link: true,
  shape: atomButtonShapes.CIRCULAR,
  size: atomButtonSizes.LARGE
}
